var UiPasswordIndicatorComponent = /** @class */ (function () {
    function UiPasswordIndicatorComponent() {
    }
    Object.defineProperty(UiPasswordIndicatorComponent.prototype, "enabledRules", {
        get: function () {
            var _this = this;
            return [
                'length',
                'hasLowerCase',
                'hasUpperCase',
                'hasDigits',
                'hasSpecialCharacter',
            ].filter(function (stringKey) {
                var key = stringKey;
                return _this.passwordComplexity[key];
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiPasswordIndicatorComponent.prototype, "percent", {
        get: function () {
            var _this = this;
            if (!this.state) {
                return 100;
            }
            // give 10% for each extra rule
            // length is always there and we remove it from "extras"
            var extraRulesLength = this.enabledRules.length * 10 - 10;
            var passwordRatio = this.state.length != null ? this.state.length / this.passwordComplexity.length : 1;
            var passwordLength = Math.min(1, passwordRatio) * (100 - extraRulesLength);
            var validRulesLength = this.enabledRules.reduce(function (prev, ruleKey) {
                var key = ruleKey;
                return !_this.state[key] && key !== 'length' ? prev + 10 : prev;
            }, 0);
            return passwordLength + validRulesLength;
        },
        enumerable: true,
        configurable: true
    });
    return UiPasswordIndicatorComponent;
}());
export { UiPasswordIndicatorComponent };
